import React, { useEffect, useState, useRef } from "react";
import { SocialIcon } from "react-social-icons";
import { FaQuestion } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { Volume2, VolumeX } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import EnquiryForm from "../../page_content/enquiry_form/EnquiryForm";
import "./banner.css";

const Banner = () => {
  const navigate = useNavigate();
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [videoSrc, setVideoSrc] = useState("");

  const toggleMute = () => {
    const video = videoRef.current;
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setVideoSrc("/assets/video/MANET Film For Mobile.mp4");
      } else {
        setVideoSrc("/assets/video/MANET Film For Website 2026  1897-577_ Without Logo.mp4");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="banner">
      {/* Sticky Buttons — fixed on all pages */}
      <div className="bnr-enquiry">
        <Link to="/admissions/admission-2026" className="bnr-btn">
          Apply Now
        </Link>

        <div className="enquiry-button-container">
          <button
            className="bnr-btn"
            onClick={() => setShowEnquiryForm(prev => !prev)}
          >
            Enquiry Now
          </button>

          {showEnquiryForm && (
            <div className="enquiry-form-slide">
              <div className="form-header">
                <h3>Quick Enquiry</h3>
                <p>Get information about our courses</p>
                <button
                  className="enquiry-close-btn"
                  onClick={() => setShowEnquiryForm(false)}
                >
                  <IoClose size={22} />
                </button>
              </div>
              <EnquiryForm isSticky={true} />
            </div>
          )}
        </div>

        <div className="social-icons">
          <SocialIcon
            className="bnr-social-icons fade-in"
            url="https://api.whatsapp.com/send/?phone=918308010405&text&type=phone_number&app_absent=0"
            network="whatsapp"
            bgColor="#25D366"
          />
          <div
            className="fa-question-wrapper"
            style={{ marginTop: "10px", cursor: "pointer" }}
            onClick={() => navigate("/admissions/admission-faq")}
          >
            <FaQuestion className="faq-icon" />
          </div>
        </div>
      </div>

      {/* Video Section */}
      <section className="bnr-video">
        <div className="bnr-video-container">
          <video ref={videoRef} autoPlay loop muted={isMuted} playsInline className="bnr-video">
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <button onClick={toggleMute} className="volume-btn">
            {isMuted ? <VolumeX size={25} color="#fff" /> : <Volume2 size={25} color="#fff" />}
          </button>
        </div>
      </section>

      {/* Notice Bar */}
      <section className="bnr-section-two">
        <h3 className="bnr-notice-title">Important Notice</h3>
        <marquee className="bnr-notice-text">
          Admissions are open for A.Y. 2026–27.
        </marquee>
      </section>
    </div>
  );
};

export default Banner;
